import {API, Storage} from 'aws-amplify';
import LogRocket from 'logrocket';

function getMyInitiDocumentDb(params) {

    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'file',
            command: 'find',
            skip: ((params.pageSize * params.page) - params.pageSize),
            limit: (params.pageSize * params.page),
            sort: [["_id", -1]],
            query: {}
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDocumentDbCount() {

    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'file',
            command: 'count_documents',
            query: {}
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getHeadersDownload(originalFile, originalName, bucket) {
    let myInitDb = {
        body: {
            bucket: bucket,
            key: originalFile
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            'Access-Control-Request-Headers': 'access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,authorization,content-type,drtoken,x-amz-date,x-amz-security-token',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitUpload(client, key, oname) {
    let body = {
        clientName: client,
        originalName: oname,
        srcBucket: process.env.REACT_APP_SRC_BUCKET,
        user: localStorage.getItem('tbClientes'),
        srcKey: key
    };

    let myInit = {
        body: body, // replace this with attributes you need
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };

    return myInit;
}

function newNameFile(filename) {
    let ext = filename.split('.').pop();
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });

    return uuid + '.' + ext;
}

export default {
    getFiles: (params = {}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb(params)).then(response => {
            return response.response;
        }),
    getFilesCount: () =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbCount()).then(response => {
            return response.response;
        }),
    downloadFiles: (originalFile, originalName, bucket) =>
        API.post('dr', '/download', getHeadersDownload(originalFile, originalName, bucket))
            .then(response => {
                //alert(originalName);
                const a = document.createElement('a');
                a.setAttribute('hidden', '');
                a.setAttribute('href', response.presigned_url);
                a.setAttribute('download', 'Teste');
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch(err => {
                LogRocket.captureException(err);
                alert('Ocorreu um erro ao fazer o download.');
            }),

    uploadFile: (data, config, newfile) =>
        Storage.put(newNameFile(newfile.name), newfile.file, {
            level: 'private'
        })
            .then(response => {
                if (response.key !== '') {
                    Storage.get(response.key, {level: 'private', expires: 1}).then(result => {
                        let regex = new RegExp('.com/(.*?)?X-Am', 'i');
                        let resul = regex.exec(decodeURIComponent(result));
                        resul = resul[1].slice(0, resul[1].length - 1);
                        API.post('dr', '/newFile', getMyInitUpload(process.env.REACT_APP_ARMEN_THEME, resul, newfile.name))
                            .then(resp => {
                                return resp;
                            })
                            .catch(err => {
                                LogRocket.captureException(err);
                                //  alert('Ocorreu um erro ao fazer o upload. COD.1');
                            });
                    });
                }
                return response;
            })
            .catch(err => {
                LogRocket.captureException(err);
                alert('Ocorreu um erro ao fazer o upload. COD.2');
                let errorMessage = '';
                errorMessage = 'Ocorreu um erro ao fazer upload do arquivo. COD.3';
                throw errorMessage;
            })
};
